<template>
  <div class="font-mulish leading-none">
    <slot />
  </div>
</template>
